// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-primary[data-v-3a9b0e74]{background-color:#92434e;border:#92434e}.btn-primary[data-v-3a9b0e74]:hover{background-color:#cb5e6d;border:#cb5e6d}.btn-primary[data-v-3a9b0e74]:focus,.btn[data-v-3a9b0e74]:focus{outline:none}.btn[data-v-3a9b0e74]:focus{box-shadow:none}", ""]);
// Exports
module.exports = exports;
